import { render } from "./check_var.vue?vue&type=template&id=171b810f"
import script from "./check_var.vue?vue&type=script&lang=js"
export * from "./check_var.vue?vue&type=script&lang=js"

import "./check_var.vue?vue&type=style&index=0&id=171b810f&lang=css"

import exportComponent from "/var/www/kutchinaasp-uat.kutchina.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__